import { createAsyncThunk } from '@reduxjs/toolkit'
import { taskTrackerApi } from '../../api/taskTracker.api'
import type {
  GetTaskTrackerBoardRefreshItemsParams,
  TaskTrackerBoardRefreshItemsResult,
} from '../domain.types'
import { getErrorMessage } from '../shared/thunk.utils'
import type { RootState } from '@store/redux.store'
import type { TaskTrackerState } from '../index'

type AppState = RootState & {
  taskTracker: TaskTrackerState
}

export const refreshBoardItemsThunk = createAsyncThunk(
  'taskTracker/refreshBoardItems',
  async (
    payload: GetTaskTrackerBoardRefreshItemsParams,
    { getState, rejectWithValue },
  ) => {
    const state = getState() as AppState
    const kanban = state.taskTracker.boardKanban.byBoardId[payload.boardId]
    if (!kanban) {
      return rejectWithValue('Доска не загружена')
    }

    const hasColumns =
      (payload.columnSettings?.length ?? 0) > 0 ||
      (payload.columnIds?.length ?? 0) > 0
    const hasSummaries = (payload.summaryIds?.length ?? 0) > 0

    if (!hasColumns && !hasSummaries) {
      return {
        boardId: payload.boardId,
        result: {
          columns: [],
          summaries: [],
        } satisfies TaskTrackerBoardRefreshItemsResult,
      }
    }

    try {
      const result = await taskTrackerApi.refreshBoardItems(payload)
      return {
        boardId: payload.boardId,
        result,
      }
    } catch (error: unknown) {
      return rejectWithValue(
        getErrorMessage(error, 'Не удалось обновить колонки и сводки доски'),
      )
    }
  },
)
